<script setup lang="ts">

</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M0.5 16V2.90909C0.5 2.50909 0.646875 2.16667 0.940625 1.88182C1.23438 1.59697 1.5875 1.45455 2 1.45455H9.575C9.525 1.69697 9.5 1.93939 9.5 2.18182C9.5 2.42424 9.525 2.66667 9.575 2.90909H2V12.4545L2.8625 11.6364H14V5.74545C14.2875 5.68485 14.5563 5.60303 14.8063 5.5C15.0563 5.39697 15.2875 5.26061 15.5 5.09091V11.6364C15.5 12.0364 15.3531 12.3788 15.0594 12.6636C14.7656 12.9485 14.4125 13.0909 14 13.0909H3.5L0.5 16ZM13.25 4.36364C12.625 4.36364 12.0938 4.15152 11.6562 3.72727C11.2188 3.30303 11 2.78788 11 2.18182C11 1.57576 11.2188 1.06061 11.6562 0.636364C12.0938 0.212121 12.625 0 13.25 0C13.875 0 14.4063 0.212121 14.8438 0.636364C15.2813 1.06061 15.5 1.57576 15.5 2.18182C15.5 2.78788 15.2813 3.30303 14.8438 3.72727C14.4063 4.15152 13.875 4.36364 13.25 4.36364Z" fill="#2563EB"/>
</svg>
</template>

<style scoped lang="scss">

</style>
